// @ts-ignore
import variables from 'styles/_variables.scss';
import { TFunction } from 'i18next';
import { WHITE_COLOR } from 'utils/constants';
import {
	SATISFACTION_LEVELS,
	STATISTIC_DATA_GLOBAL_NAME,
} from 'modules/admin-panel/pages/results/utils';
import { StaticTableColumns } from 'modules/admin-panel/pages/results/models';

export const getDisplayedValue = (
	value: string | number | null,
	t: TFunction,
) => {
	if (value === STATISTIC_DATA_GLOBAL_NAME) return t('global');
	if (value === null) return t('no_applicable');
	return value;
};

const getCellColor = (score: number | null): string => {
	if (score === null) {
		return variables.lightBackgroundDense;
	}

	if (score < SATISFACTION_LEVELS.ok.min) {
		return variables.tableDangerColor;
	}

	if (score < SATISFACTION_LEVELS.good.min) {
		return variables.tableMediumColor;
	}
	return variables.tablePositiveColor;
};

export const getStatisticTableCellColor = (
	columnId: string,
	score: string | number | null,
) => {
	return Object.keys(StaticTableColumns).includes(columnId)
		? WHITE_COLOR
		: getCellColor(score as number | null);
};

export const getCellZIndex = (rowName: string, columnId: string) => {
	let zIndex = 0;
	if (
		rowName === STATISTIC_DATA_GLOBAL_NAME ||
		columnId === StaticTableColumns.name ||
		columnId === StaticTableColumns.responses
	)
		zIndex = 2;
	if (
		columnId === StaticTableColumns.name &&
		rowName === STATISTIC_DATA_GLOBAL_NAME
	)
		zIndex = 4;
	if (
		columnId === StaticTableColumns.responses &&
		rowName === STATISTIC_DATA_GLOBAL_NAME
	)
		zIndex = 5;

	return zIndex;
};
